import { Spin, Table, Button } from "antd";
import React, { useEffect, useState } from "react";
import Axios from "axios";
import cogoToast from "cogo-toast";
import CourseInfo from "./info";

const token = localStorage.getItem("token_mg_WB");
const api = process.env.REACT_APP_API_URL;

const TableCourse = (props) => {
  const { refreshKey } = props;
  const [loading, setLoading] = useState(true);
  const [infoVisible, setInfoVisible] = useState(false);
  const [courses, setCourses] = useState([]);
  const [cCourse, setCCourse] = useState();

  const columns = [
    { title: "ID", dataIndex: "_id", key: "_id" },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Batches",
      dataIndex: "batches",
      key: "batches",
      render: (key) => <span>{key.length}</span>,
    },
    {
      title: "Info",
      dataIndex: "_id",
      key: "_id",
      render: (key, obj) => (
        <Button
          type="danger"
          onClick={() => {
            setCCourse(obj);
            setInfoVisible(true);
          }}
        >
          View Info
        </Button>
      ),
    },
  ];
  useEffect(() => {
    Axios.get(`${api}/cb/course`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      const { error, courses } = response.data;
      if (error) {
        cogoToast.error("Error loading classes", { position: "top-right" });
      } else {
        setCourses(courses);
        setLoading(false);
      }
    });
  }, [refreshKey]);
  return (
    <>
      {loading ? (
        <Spin
          style={{ marginTop: "3%", display: "flex", justifyContent: "center" }}
        />
      ) : (
        <>
          {infoVisible ? (
            <CourseInfo
              infoVisible={infoVisible}
              setInfoVisible={setInfoVisible}
              cCourse={cCourse}
            />
          ) : null}
          <Table
            rowKey="_id"
            dataSource={courses}
            columns={columns}
            pagination={{
              defaultPageSize: 100,
              position: ["topRight"],
              total: courses.length,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} courses`,
            }}
          />
        </>
      )}
    </>
  );
};

export default TableCourse;
